import store from '@/store'
import { refreshPostHogFlags as refreshFromApi } from '@/services/api/posthogFlags'

export function getPostHogFlag(flagKey) {
  const slug = store.getters['tenant/current_tenant_slug']
  const info = store.state.tenant.tenantAccess?.[slug]
  if (!info?.posthog_flags) return false
  return info.posthog_flags[flagKey] ?? false
}

export function isPostHogFlagEnabled(flagKey) {
  return !!getPostHogFlag(flagKey)
}

export async function refreshPostHogFlags() {
  const data = await refreshFromApi()
  store.commit('tenant/UPDATE_POSTHOG_FLAGS', data)
  return data
}
